<template>
  <div class="user" >
    <el-dialog
      :visible.sync="show"
      :title="`${title}详情`"
      width="60%"
      :center="false"
      :before-close="close"
      :close-on-click-modal="false"
    >
      <div class="delail">
        <el-table
          :data="tableData"
          style="width: 100%"
          size="small"
          border
          fit
          highlight-current-row
          >
          <el-table-column :prop="item.prop" :label="item.title" align="center" 
          v-for="(item,index) in columnList" :key="index" show-overflow-tooltip />
        </el-table>
        <div class="pagination-container-one">
          <el-pagination
            v-if="total > 0"
            :current-page="page"
            :page-sizes="[10, 20, 30, 50, 100]"
            :page-size="10"
            :total="total"
            background
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleJuniorsSizeChange"
            @current-change="handleJuniorsSizeChange"
          >
          </el-pagination>
        </div>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import {
  getAcctFlow,
  getAddOrderList,
  getPendingAfterOrderList,
  getNewAddUserList,
} from "@/api/dashboard";
import {formatDateOne} from '@/utils/utils'
import {
  getValue,
  BALANCE_TYPE,
  ORDER_STATUS,
  AFTER_SALE_STATUS
} from "@/utils/enumUtile";
export default {
  data() {
    return {
      tableData:[],
      page:1,
      pageSize:10,
      columnList:[],
      total:0
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    index:{
      type: Number,
      default: -1,
    },
    title:{
      type:String,
      default:'详情'
    }
  },
  watch:{
    show(cur, pre) {
      console.log('cur',cur,pre,this.index)
      if(cur){
        this.getTable();
      }
    },
  },
  methods: {
    handleJuniorsSizeChange(val) {
      this.page = val;
      this.getTable();
    },
    close() {
      this.tableData = [];
      this.page = 1;
      this.pageSize = 10;
      this.columnList = [];
      this.total = 0;
      this.$emit("close");
    },
    getTable(){
      console.log('getT')
      let url = getAcctFlow;
      let params = {
        page:this.page,
        pageSize:this.pageSize
      }
      if(this.index == 0){
        url = getAcctFlow;
        params['category'] = 'expend';
      }else if(this.index == 1){
        url = getAcctFlow;
        params['category'] = 'balance';
      }else if(this.index == 2){
        url = getAcctFlow;
        params['category'] = 'raffle';
      }else if(this.index == 3){
        url = getAcctFlow;
        params['category'] = 'redpacket';
      }else if(this.index == 4){
        url = getAcctFlow;
        params['category'] = 'vcoin';
      }else if(this.index == 5){
        url = getAddOrderList;
      }else if(this.index == 6){
        url = getPendingAfterOrderList;
      }else if(this.index == 7){
        url = getNewAddUserList;
      }

      url(params).then(res=>{
        this.columnList = [];
        if(this.index < 5){
          this.tableData = res.data.entitys || [];
          this.total = res.data.totalCount;
          this.columnList = [
            {prop:'id',title:'ID'},
            {prop:'amount',title:'金额'},
            {prop:'typeText',title:'类型'},
            {prop:'remark',title:'备注'},
            {prop:'time',title:'时间'},
          ]
          this.tableData.forEach(item=>{
            item.typeText = getValue(BALANCE_TYPE,item.type);
            item.time = formatDateOne(new Date(item.ctdate), 4);
          })
        }else if(this.index == 5){
          this.tableData = res.data.entitys || [];
          this.total = res.data.totalCount;
          this.columnList = [
            {prop:'userId',title:'用户ID'},
            {prop:'orderNo',title:'订单编号'},
            {prop:'goodsAmount',title:'订单金额'},
            {prop:'goodsTitle',title:'订单名称'},
            {prop:'statusTitle',title:'订单状态'},
            {prop:'time',title:'时间'},
          ]
          this.tableData.forEach(item=>{
            item.time = formatDateOne(new Date(item.ctdate), 4);
            item.goodsTitle = item.items[0].title;
            item.statusTitle = getValue(ORDER_STATUS, item.status)
          })
        }else if(this.index == 6){
          this.tableData = res.data.entitys || [];
          this.total = res.data.totalCount;
          this.columnList = [
            {prop:'userId',title:'用户ID'},
            {prop:'orderNo',title:'订单编号'},
            {prop:'refundAmount',title:'订单金额'},
            {prop:'statusTitle',title:'订单状态'},
            {prop:'time',title:'时间'},
          ]
          this.tableData.forEach(item=>{
            item.time = formatDateOne(new Date(item.ctdate), 4);
            item.statusTitle = getValue(AFTER_SALE_STATUS, item.status)
          })
        }else if(this.index == 7){
          this.tableData = res.data.entitys || [];
          this.total = res.data.totalCount;
          this.columnList = [
            {prop:'id',title:'用户ID'},
            {prop:'name',title:'用户名称'},
            {prop:'mobile',title:'手机号'},
            {prop:'time',title:'时间'},
          ]
          this.tableData.forEach(item=>{
            item.time = formatDateOne(new Date(item.ctdate), 4);
            item.name = item.name || item.nickname || '暂无名称';
          })
        }
      })
    }

  },
};
</script>

<style lang="scss">
.delail {
  width:100%;
  display: flex;
  flex-direction: column;
  .pagination-container-one{
    width:100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    margin-top:20px;
  }
}
</style>